module.exports = "/images/arrow-top.svg?4542073438a0cbeea3f3c21bf2dacec6";